import {Component, computed, inject, Input} from '@angular/core';
import {CommunicationCenterService} from '@modules/communication-center';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {EventService} from 'shared/event.service';

@Component({
    selector: 'app-premium-state',
    imports: [
        TranslateModule,
    ],
    templateUrl: './premium-state.component.html',
    styleUrl: './premium-state.component.scss'
})
export class PremiumStateComponent {

    @Input() isActive = false;
    @Input() expirationDate: Date | null = null;

    private translateService = inject(TranslateService);
    private communicationCenter = inject(CommunicationCenterService);
    private eventService = inject(EventService);

    protected isPremiumActive = computed(() => this.isActive);
    protected isLicenceExpired = computed(() => !this.isActive);
    protected shouldShowExtendButton = computed(() => {
        if (!this.isActive || !this.expirationDate) {
            return false;
        }

        const remainingMs = this.expirationDate.getTime() - Date.now();
        const thirtyDaysMs = 30 * 24 * 60 * 60 * 1000;

        return remainingMs > 0 && remainingMs <= thirtyDaysMs;
    });
    protected localeDate = computed(() => {
        if (this.expirationDate) {
            return this.expirationDate?.toLocaleDateString(this.translateService.currentLang, {
                weekday: 'long',
                day: 'numeric',
                month: 'long',
                year: 'numeric'
            });
        }
        return '';
    });

    protected expandPremiumClick($event: MouseEvent): void {
        // TODO plus tard on est sensé changer cet évent pour un plus spécifique :
        this.eventService.trackEvent('open modal', 'toolbar', 'premium');
        this.communicationCenter
            .getRoom('freemium-premium')
            .getSubject('access-premium-display-compare-modal')
            .next(true);
    }
}
